module.exports = __webpack_public_path__ + "static/media/zoom-meeting.60220248.jpeg";